import * as angular from "angular";

export class ConfirmChangeStateService {
  isEnabled: boolean = false;
  hasTransitionApproved: boolean = false;
  isDialogActive: boolean = false;

  constructor() {
  }

  getIsEnabled() {
    return this.isEnabled;
  }

  getHasTransitionApproved() {
    return this.hasTransitionApproved;
  }

  getIsDialogActive() {
    return this.isDialogActive;
  }

  // Setters
  //////////////////////////////////////

  setIsEnabled(value) {
    this.isEnabled = value;
  }

  setHasTransitionApproved(value) {
    this.hasTransitionApproved = value;
  }

  setIsDialogActive(value) {
    this.isDialogActive = value;
  }

  reset() {
    this.isEnabled = false;
    this.hasTransitionApproved = false;
    this.isDialogActive = false;
  }
}

angular
  .module('bringoz.admin.commons')
  .service('confirmChangeStateService', ConfirmChangeStateService);
